import {DelegateRepository} from './DelegateRepository';
import {ConferenceRepository} from './ConferenceRepository';
import {UserRepository} from './UserRepository';
import {AttendanceRepository} from './AttendanceRepository';
import {OrganisationRepository} from './OrganisationRepository';
import {BranchRepository} from './BranchRepository';

export class Route
{
    constructor(routeName) {
        this.routeName = routeName;
    }

    boot() {
        return {
            createDelegate: DelegateRepository.prototype.create,
            createConference: ConferenceRepository.prototype.create,
            createUser: UserRepository.prototype.create,
            filterAttendance: AttendanceRepository.prototype.create,
            createOrganisation: OrganisationRepository.create,
            createBranch: BranchRepository.create,
        };
    }

    dispatch() {
        let self = this;
        $.each(this.boot(), function(route, action){
            if (route === self.routeName){
                action.call();
                return false;
            }/* else {
                console.error(`Route ${self.routeName} is not defined. Please ensure you have specified the correct route name`)
                return false;
            }*/
        })
    }
}
